(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cws-portfolio-slider"] && !Shopify.designMode) return;
  try {
    
class CwsPortfolioSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.cws-portfolio-slider__track');
    this.slides = Array.from(this.querySelectorAll('.cws-portfolio-slider__slide'));
    this.prevBtn = this.querySelector('[data-cws-prev]');
    this.nextBtn = this.querySelector('[data-cws-next]');
    this.dots = Array.from(this.querySelectorAll('[data-cws-dot]'));
    this.currentIndex = 0;
    this.autoplayTimer = null;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

    if (!this.track || this.slides.length === 0) return;

    this.onPrevClick = () => this.go(this.currentIndex - 1);
    this.onNextClick = () => this.go(this.currentIndex + 1);
    this.onTrackScroll = () => this.onScroll();
    this.onMouseEnter = () => this.stopAutoplay();
    this.onMouseLeave = () => this.startAutoplay();

    if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrevClick);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNextClick);
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10)));
    });

    this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });

    if (this.autoplay) {
      this.startAutoplay();
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
    }

    this.updateDots(0);
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  go(index) {
    var max = this.slides.length - 1;
    if (index < 0) index = max;
    if (index > max) index = 0;
    var slide = this.slides[index];
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    this.currentIndex = index;
    this.updateDots(index);
  }

  onScroll() {
    var trackLeft = this.track.scrollLeft;
    var closest = 0;
    var closestDist = Infinity;
    this.slides.forEach((slide, i) => {
      var dist = Math.abs(slide.offsetLeft - this.track.offsetLeft - trackLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closest = i;
      }
    });
    if (closest !== this.currentIndex) {
      this.currentIndex = closest;
      this.updateDots(closest);
    }
  }

  updateDots(index) {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.go(this.currentIndex + 1), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) clearInterval(this.autoplayTimer);
  }
}

if (!customElements.get('cws-portfolio-slider')) {
  customElements.define('cws-portfolio-slider', CwsPortfolioSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
